/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_Transaction_NoInputs */

const en_admin_credits_transaction_no = /** @type {(inputs: Admin_Credits_Transaction_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transaction No`)
};

const zh_admin_credits_transaction_no = /** @type {(inputs: Admin_Credits_Transaction_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交易单号`)
};

/**
* | output |
* | --- |
* | "Transaction No" |
*
* @param {Admin_Credits_Transaction_NoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_credits_transaction_no = /** @type {((inputs?: Admin_Credits_Transaction_NoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_Transaction_NoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_credits_transaction_no(inputs)
	return zh_admin_credits_transaction_no(inputs)
});
export { admin_credits_transaction_no as "admin.credits.transaction_no" }